import { VesselScreeningComponent } from './vessel-screening.component';
import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil, JhiResolvePagingParams } from 'ng-jhipster';
import { UserRouteAccessService } from 'src/app/core';
import { Observable } from 'rxjs';
import { VesselInformationMySuffix } from 'src/app/shared/model/vessel-information-my-suffix.model';
import { VesselInformationMySuffixService } from './vessel-information-my-suffix.service';
import { VesselInformationMySuffixComponent } from './vessel-information-my-suffix.component';
import { VesselInformationMySuffixDetailComponent } from './vessel-information-my-suffix-detail.component';
import { VesselInformationMySuffixUpdateComponent } from './vessel-information-my-suffix-update.component';
import { VesselInformationMySuffixDeletePopupComponent } from './vessel-information-my-suffix-delete-dialog.component';
import { IVesselInformationMySuffix } from 'src/app/shared/model/vessel-information-my-suffix.model';
import { IHSVesselInformationMySuffixComponent } from './IHS-vessel-information-my-suffix.component';
import { VesselScreeningMySuffixComponent } from './vessel-screening-my-suffix.component';

@Injectable({ providedIn: 'root' })
export class VesselInformationMySuffixResolve implements Resolve<IVesselInformationMySuffix> {
    constructor(private service: VesselInformationMySuffixService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            return this.service.find(id).map((vesselInformation: HttpResponse<VesselInformationMySuffix>) => vesselInformation.body);
        }
        return Observable.of(new VesselInformationMySuffix());
    }
}

export const vesselInformationRoute: Routes = [
    {
        path: 'vessel-information',
        component: VesselInformationMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'VesselInformations'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'vessel-information/:id/view',
        component: VesselInformationMySuffixDetailComponent,
        resolve: {
            vesselInformation: VesselInformationMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'VesselInformations'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'vessel-information/new',
        component: VesselInformationMySuffixUpdateComponent,
        resolve: {
            vesselInformation: VesselInformationMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'VesselInformations'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'vessel-information/:id/edit',
        component: VesselInformationMySuffixUpdateComponent,
        resolve: {
            vesselInformation: VesselInformationMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'VesselInformations'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'ihs-vessel-information',
        component: IHSVesselInformationMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'IHSVesselInformations'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'vessel-screening',
        component: VesselScreeningMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'CLIENT',
                'CLIENT_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'vessel-screening'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'vessel-screening-new/:id',
        component: VesselScreeningComponent,
        data: {
            authorities: [
                'CLIENT',
                'CLIENT_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT',
            ],
            defaultSort: 'id,asc',
            pageTitle: 'vessel-screening-new'
        },
        canActivate: [UserRouteAccessService]
    },

       {
        path: 'vessel-screening-new',
        component: VesselScreeningComponent,
        data: {
            authorities: [
                'CLIENT',
                'CLIENT_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
            ],
            defaultSort: 'id,asc',
            pageTitle: 'vessel-screening-new'
        },
        canActivate: [UserRouteAccessService]
    }


];

export const vesselInformationPopupRoute: Routes = [
    {
        path: 'vessel-information/:id/delete',
        component: VesselInformationMySuffixDeletePopupComponent,
        resolve: {
            vesselInformation: VesselInformationMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'VesselInformations'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
